var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 2.75305V6.34905C14.186 6.83605 14.38 7.30405 14.726 7.64905C15.0729 7.99442 15.5425 8.18824 16.032 8.18805H20.157",
    stroke: "#BF1E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.56803V17.136C20.2301 17.6965 20.0996 18.2474 19.8658 18.7571C19.6321 19.2669 19.2997 19.7253 18.888 20.106C18.4759 20.4885 17.9925 20.786 17.4654 20.9817C16.9383 21.1773 16.3778 21.2671 15.816 21.246H8.226C7.66074 21.2719 7.09594 21.1859 6.56398 20.993C6.03201 20.8001 5.54335 20.5041 5.126 20.122C4.71027 19.7403 4.37454 19.2797 4.13833 18.7671C3.90211 18.2545 3.77011 17.7001 3.75 17.136V6.86203C3.76985 6.3016 3.90042 5.75065 4.13418 5.24091C4.36794 4.73118 4.70026 4.27274 5.112 3.89203C5.52408 3.50955 6.00748 3.21201 6.53458 3.01641C7.06169 2.8208 7.62217 2.73096 8.184 2.75203H13.898C14.7703 2.74895 15.6123 3.07169 16.259 3.65703L19.219 6.37903C19.5349 6.65111 19.7899 6.98663 19.9675 7.36378C20.1452 7.74092 20.2414 8.15123 20.25 8.56803Z",
    stroke: "#BF1E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.273V10.499",
    stroke: "#BF1E2E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89404 14.42L11.559 17.086C11.6167 17.1444 11.6854 17.1907 11.7611 17.2223C11.8368 17.254 11.918 17.2702 12 17.2702C12.0821 17.2702 12.1633 17.254 12.239 17.2223C12.3147 17.1907 12.3834 17.1444 12.441 17.086L15.106 14.421",
    stroke: "#BF1E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf-download.29eab60dcd60ce9c77b0d5cd4605825d.svg";
export { ForwardRef as ReactComponent };